import { GameLobby } from './gamelobby';
/**
 * Created by karthikeyan.k on 27-11-2018.
 */
export class FC21Lobby extends GameLobby {
  bets: string;
  splits: string;
  soft17: boolean;
  supernatural: string;
  naturaltwentyone: string;
  doublenatural: string;
  naturalzero: string;
  insurance: string;
  colorcardinsurance: string;
  whitecardinsurance: string;
  russianroulette17: string;
  russianroulette18: string;
  russianroulette19: string;
  russianroulette20: string;
  supernaturalpercentage: string;
  naturaltwentyonepercentage: string;
  doublenaturalpercentage: string;
  naturalzeropercentage: string;
  colorcardinsurancepercentage: string;
  whitecardinsurancepercentage: string;
  russianroulette17percentage: string;
  russianroulette18percentage: string;
  russianroulette19percentage: string;
  russianroulette20percentage: string;
}
